<template>
  <div class="tla-form-group tla-form-group--margin-medium">
    <label class="tla-form-group__label tla-form-group__label--required" v-html="contactPreferenceLabel"></label>

    <div class="tla-form-group__touch-points">
      <touchpoint v-for="(item) in options"
        :key="item.touchpointValue"
        :collectionName="'contactPreference'"
        :inputId="item.touchpointValue"
        :inputValue="item.touchpointValue"
        :isSelected="item.preSelect"
        :isRadioStyle="true"
        :validationScope="validationScope"
        @contactPreference="submitContactPreference($event)">
        <div class="generic-touchpoint__text" slot="touchpoint" v-html="item.touchpointName"></div>
      </touchpoint>
    </div>
    <span class="tla-form-group__message" :class="getValidationClass('contactPreference', 'message')">
      Please select an option.
    </span>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Inject } from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import { validationService } from '@/services/ValidationService';
import GenericTouchpointComponent from '../ui/GenericTouchPointComponent.vue';
import Touchpoint from '../../models/Touchpoint';
import ExtraData from '../../models/ExtraData';

@Component({
  components: {
  touchpoint: GenericTouchpointComponent
  }
  })
export default class ContactPreferenceComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'Would you like one of our automotive experts to assist you in your car choice? <span>*</span>' })
  public contactPreferenceLabel!: string;

  @Prop({ default: null })
  public validationScope!: string;

  public options: Touchpoint[] = [
    new Touchpoint('true', 'Yes'),
    new Touchpoint('false', 'No')
  ];

  public submitContactPreference(value: string) {
    const extraData = new ExtraData('carChoiceAssistanceRequired', value);
    this.$store.dispatch('enquiryModule/submitExtraData', extraData);
  }

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService
      .getValidationClass(this.$validator, fieldName, fieldType, false, false, this.validationScope);
  }
}
</script>
